// extracted by mini-css-extract-plugin
export default {"company":"View_company__f1ptR","info":"View_info__nkMSr","spin":"View_spin__ukdF0"};